import React from 'react';

export default function FilterBar({
  search,
  dateFrom,
  dateTo,
  onSearchChange,
  onDateFromChange,
  onDateToChange,
  onExportCsv,
  onExportExcel,
}) {
  return (
    <div className="collections-filterbar">
      <div className="collections-filterbar-fields">
        <input
          type="text"
          placeholder="Search client, product, agent, or reference..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        <input
          type="date"
          value={dateFrom}
          onChange={(event) => onDateFromChange(event.target.value)}
        />
        <input
          type="date"
          value={dateTo}
          onChange={(event) => onDateToChange(event.target.value)}
        />
      </div>
      <div className="collections-filterbar-actions">
        <button type="button" className="profile-secondary-btn" onClick={onExportCsv}>
          Export CSV
        </button>
        <button type="button" className="profile-secondary-btn" onClick={onExportExcel}>
          Export Excel
        </button>
      </div>
    </div>
  );
}
